import { LINK_IN_BIO_SOCIAL_BRAND_NAMES, LINK_IN_BIO_SOCIAL_PLATFORMS } from '@repo/lib';
import type { LinkInBioSocialPlatform } from '@repo/lib';

const TEXT_KEYS = [
  'portal',
  'canceled',
  'soldOut',
  'online',
  'emailTitle',
  'emailPlaceholder',
  'emailButton',
  'emailThanks',
  'emailError',
] as const;

type TextKey = (typeof TEXT_KEYS)[number];

export type LinkInBioLabels = Record<TextKey, string> & {
  social: Record<LinkInBioSocialPlatform, string>;
};

type LinkInBioMessages = {
  linkInBio?: Partial<Omit<LinkInBioLabels, 'social'>> & {
    social?: { email?: string; website?: string };
  };
};

export function getLinkInBioLabels(
  messages: LinkInBioMessages | null | undefined,
  fallback: LinkInBioMessages,
): LinkInBioLabels {
  const own = messages?.linkInBio ?? {};
  const base = fallback.linkInBio ?? {};
  const pick = (key: TextKey) => own[key] || base[key] || '';
  const translatedSocial = {
    email: own.social?.email || base.social?.email || 'Email',
    website: own.social?.website || base.social?.website || 'Website',
  };

  return {
    ...(Object.fromEntries(TEXT_KEYS.map(key => [key, pick(key)])) as Record<TextKey, string>),
    social: Object.fromEntries(
      LINK_IN_BIO_SOCIAL_PLATFORMS.map(platform => [
        platform,
        LINK_IN_BIO_SOCIAL_BRAND_NAMES[platform] ??
          translatedSocial[platform as keyof typeof translatedSocial] ??
          platform,
      ]),
    ) as Record<LinkInBioSocialPlatform, string>,
  };
}
